// extracted by css-extract-rspack-plugin
export default {"showOnHoverOnly":"ProjectTrafficLightStatusSwitcherCell_showOnHoverOnly__uWa9Y"};